import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { Device, DeviceCart, Role } from '@kion/data-models';
import { TranslateService } from '@ngx-translate/core';
// tslint:disable-next-line:nx-enforce-module-boundaries
import { DropDownOption } from '../../../../../../shared/ui/src/lib/shared/elements/drop-down/drop-down.component';

@Component({
  selector: 'kion-basket-info',
  templateUrl: './basket-info.component.html',
  styleUrls: ['./basket-info.component.scss']
})
export class BasketInfoComponent implements OnInit {

  @Input() deviceCart: DeviceCart;
  @Input() device: Device;
  @Input() roles: Role[];

  // tslint:disable-next-line:no-output-rename
  @Output('deleteQuote') deleteQuoteEmitter: EventEmitter<void> = new EventEmitter<void>();
  // tslint:disable-next-line:no-output-rename
  @Output('updateStatus') updateStatusEmitter: EventEmitter<string> = new EventEmitter<string>();

  options: DropDownOption[];

  @ViewChild('dropDown') dropDown: ElementRef;

  constructor(private translateService: TranslateService) { }

  ngOnInit(): void {
    this.options = [
      {
        key: 'approved',
        value: "",
        selected: false
      },
      {
        key: 'created',
        value: "",
        selected: false
      }
    ];
  }

  get statusOptions(): DropDownOption[] {
    return this.options.map((option) => (
        {
          ...option,
          selected: option.key === this.device?.quote?.status?.toLowerCase(),
          value: this.getTranslationByKey(option.key)
        }
      )
    )
  }

  hasBuyerRole(): boolean {
    return this.roles.map(role => role.role.uid).includes('fsNwpBuyer')
  }
  hasApproverRole(): boolean {
    return this.roles.map(role => role.role.uid).includes('fsNwpApprover')
  }

  get avtiveOption(): string {
    return this.statusOptions.find(option => option.selected)?.key || 'created';
  }

  get employee(): string {
    if (this.device.quote) {
      if (this.device.quote.employee) {
        if (this.device.quote.employee.firstName && this.device.quote.employee.lastName) {
          return this.device.quote.employee.firstName + ' ' + this.device.quote.employee.lastName;
        }
        return this.device.quote.employee.uid;
      }
      return this.translateService.instant('basket.employee.unknown');
    }
    return this.translateService.instant('basket.employee.unknown');
  }

  updateStatus(o: DropDownOption) {
    this.updateStatusEmitter.emit(o.key);
  }

  toggleDropDown() {
    if (this.dropDown.nativeElement.classList.contains('open')) {
      this.dropDown.nativeElement.classList.remove('open');
      return;
    }
    this.dropDown.nativeElement.classList.add('open');
  }

  closeDropDown() {
    this.dropDown.nativeElement.classList.remove('open');
  }

  deleteButtonClicked(event: MouseEvent) {
    event.stopPropagation();
    this.dropDown.nativeElement.classList.remove('open');
    this.deleteQuoteEmitter.emit();
  }

  private getTranslationByKey(key: string) {
    if (key === 'approved') {
      return this.translateService.instant('basket.status.approved')
    }
    return  this.translateService.instant('basket.status.created')
  }
}
